import React from 'react';

import firebase from '../../common/firebase';
import { Container } from '../../common/base';
import { Grid, Col, Anchor } from '../../common/interfaces';
import { HeroWrapper, HeroImg } from './Styled';
import { Trans, withTranslation } from '../../common/libs/i18n';

class HomeHero extends React.Component {
  constructor() {
    super();
    this.state = {
      buttonURL: '/signin'
    };
    this.unsubscribe = undefined;
  }

  componentDidMount() {
    this.unsubscribe = firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.setState({ buttonURL: '/dashboard' });
      } else this.setState({ buttonURL: '/signin' });
    });
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  render() {
    const { buttonURL } = this.state;
    return (
      <HeroWrapper>
        <Container>
          <Grid>
            <Col lg={5} md={12}>
              <h1>
                <Trans i18nKey="introduction.title">The First Stablecoin Backed By Rupiah</Trans>
              </h1>
              <p>
                <Trans i18nKey="introduction.subtitle">
                  Rupiah Token (IDRT) is a crypto asset on the Ethereum Blockchain that gives you
                  access to global crypto exchanges. You can always redeem 1 IDRT for Rp 1, giving
                  it a stable price.
                </Trans>
              </p>
              <Anchor type="button" size="large" prefetch href={buttonURL}>
                <Trans i18nKey="introduction.button_get">Get Rupiah Token (IDRT)</Trans>
              </Anchor>
            </Col>
          </Grid>
        </Container>
        <HeroImg>
          <img src="../../../static/images/illustrations/hero-home.svg" alt="" />
        </HeroImg>
      </HeroWrapper>
    );
  }
}

export default withTranslation('common')(HomeHero);
